import i18n from "@/i18n";

const routes = {
  path: "/minigame",
  name: "MiniGame",
  component: () =>
    import(/* webpackChunkName: "minigame" */ "@/views/minigame/Main"),
  children: [
    {
      path: "minigamelist",
      alias: "",
      name: "MiniGameList",
      component: () =>
        import(
          /* webpackChunkName: "minigame" */ "@/views/minigame/MiniGameList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame"),
        m_subtitle: i18n.t("page.event.minigame"),
        step: [i18n.t("menu.event.event"), i18n.t("page.event.minigame")],
        menu_num: 6,
        sub_menu_num: 61,
        location: "/minigame/minigamelist",
      },
    },
    {
      path: "winaminigamelist/:eventno+",
      name: "WinAMiniGameList",
      component: () =>
        import(
          /* webpackChunkName: "event" */ "@/views/minigame/WinAMiniGameList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.leaderboard"),
        m_subtitle: i18n.t("page.event.leaderboard"),
        menu_num: 6,
        sub_menu_num: 62,
        step: [i18n.t("menu.event.event"), i18n.t("page.event.minigame")],
        location: "/minigame/minigamelist",
      },
    },
    {
      path: "minigameranking/:eventno+",
      name: "MiniGameRanking",
      component: () =>
        import(
          /* webpackChunkName: "event" */ "@/views/minigame/MiniGameRanking"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.leaderboard"),
        m_subtitle: i18n.t("page.event.leaderboard"),
        menu_num: 6,
        sub_menu_num: 63,
        step: [i18n.t("menu.event.event"), i18n.t("page.event.minigame")],
        location: "/minigame/minigamelist",
      },
    },
    {
      path: "minigamewrite",
      name: "MiniGameWrite",
      component: () =>
        import(
          /* webpackChunkName: "minigame" */ "@/views/minigame/MiniGameWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.mingame_write"),
        step: [i18n.t("menu.event.event"), i18n.t("page.event.mingame_write")],
        menu_num: 6,
        sub_menu_num: 64,
        location: "/minigame/minigamelist",
      },
    },
    {
      path: "minigamewrite/:eventno+",
      name: "MiniGameModify",
      component: () =>
        import(
          /* webpackChunkName: "minigame" */ "@/views/minigame/MiniGameWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.mingame_edit"),
        step: [i18n.t("menu.event.event"), i18n.t("page.event.mingame_edit")],
        menu_num: 6,
        sub_menu_num: 64,
        location: "/minigame/minigamelist",
      },
    },
    {
      path: "winninglist",
      name: "MiniGameWinningList",
      component: () =>
        import(
          /* webpackChunkName: "minigame" */ "@/views/minigame/MiniGameWinningList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.event.minigame_winners"),
        step: [
          i18n.t("menu.event.event"),
          i18n.t("menu.event.minigame_winners"),
        ],
        menu_num: 6,
        sub_menu_num: 65,
        location: "/minigame/winninglist",
      },
    },
  ],
};

export default routes;
